import * as R from 'ramda';

import { updateFields, addNewField, replaceUpdatedField } from './utils';

import {
    EDITOR_GET_FORM,
    EDITOR_SELECT_FIELD,
    EDITOR_UPDATE_FIELD,
    EDITOR_ADD_FORM_FIELD,
    EDITOR_DELETE_FIELD,
    EDITOR_CLEAR_FORM,
    EDITOR_UPDATE_FORM_SETTINGS,
    EDITOR_REORDER_FIELDS,
    EDITOR_COPY_FIELD,
    EDITOR_CHANGE_FIELD_COMPONENT
} from './constants';

const defaultState = {
    form: null,
    selectedField: null
};

const formEditor = (state = defaultState, { type, payload }) => {
    let updatedFields, updatedForm;
    switch (type) {
        case EDITOR_GET_FORM:
            const form = payload;
            const selectedField = payload.jsonSchema.fields[0].id;
            return R.merge(state, { form, selectedField });
        case EDITOR_SELECT_FIELD:
            return R.merge(state, { selectedField: payload });
        case EDITOR_COPY_FIELD:
        case EDITOR_ADD_FORM_FIELD:
            updatedFields = addNewField(state.form.jsonSchema.fields, state.selectedField, payload);
            updatedForm = R.assocPath(['jsonSchema', 'fields'], updatedFields, state.form);
            return R.merge(state, { form: updatedForm, selectedField: payload.id });
        case EDITOR_UPDATE_FIELD:
            updatedFields = updateFields(state.form.jsonSchema.fields, payload);
            return R.assocPath(['form', 'jsonSchema', 'fields'], updatedFields, state);
        case EDITOR_DELETE_FIELD:
            updatedForm = R.assocPath(['jsonSchema', 'fields'], payload, state.form);
            return R.merge(state, { form: updatedForm });
        case EDITOR_CLEAR_FORM:
            return defaultState;
        case EDITOR_UPDATE_FORM_SETTINGS:
            updatedFields = R.omit(['userId'], payload);
            updatedForm = R.merge(state.form, updatedFields);
            return R.merge(state, { form: updatedForm });
        case EDITOR_REORDER_FIELDS:
            updatedForm = R.assocPath(['jsonSchema', 'fields'], payload, state.form);
            return R.merge(state, { form: updatedForm });
        case EDITOR_CHANGE_FIELD_COMPONENT:
            updatedFields = replaceUpdatedField(state.form.jsonSchema.fields, payload);
            return R.assocPath(['form', 'jsonSchema', 'fields'], updatedFields, state);
        default:
            return state;
    }
};

export default formEditor;
